import { Box, Grid, Typography } from "@mui/material";
import BookingSummary from "components/cart/booking-summary";
import Cards from "components/payment/cards";
import { ROUTES } from "constants/routes";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchCart } from "slices/cartReducer";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import FinalPayment from "./final-payment";
import PageHeader from "components/PageHeader/Pageheader";

const PaymentPage = () => {
  const navigate = useNavigate();
  const { cartReducer } = useAppSelector((state) => state);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchCart({ query: "" }));
  }, []);

  return (
    <Box>
          <PageHeader navPath={ROUTES.CART} title="Payment" />
    
      <Box
        sx={{
          display: "flex",
          gap: "20px",
          flexWrap: { sm: "wrap", xs: "wrap" },
        }}
      >
        <Box
          sx={{
            minWidth: {
              md: "25%",
              lg: "25%",
              xl: "25%",
              sm: "100%",
              xs: "100%",
            },
          }}
        >
          <Cards />
        </Box>
        <Box sx={{ flex: 1 }}>
          <Box
            sx={{
              mx: {
                md: "30px",
                lg: "30px",
                xl: "30px",
                sm: "15px",
                xs: "15px",
              },
              mb: "20px",
            }}
          >
            <FinalPayment />
          </Box>
        </Box>
      </Box>
      {/* <Grid container> */}
      {/* <Grid item sm={12} xs={12} md={5} lg={4} xl={3}> */}
      {/* </Grid> */}
      {/* <Grid item sm={12} xs={12} md={7} lg={8} xl={9}> */}

      {/* </Grid> */}
      {/* </Grid> */}
    </Box>
  );
};

export default PaymentPage;
